import { Box, Button, Container, Divider, Grid, Paper, Stack, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FormInputText } from '../../form-components/FormInputText';
import { FormInputPhone } from '../../form-components/FormInputPhone';
import AnimationPage from '../AnimationPage';
import { useToast } from 'use-toast-mui';
import { errorMessages } from '../../utils/methods';

const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s])[^\s]{8,16}$/;

export default function SectionTwo({ setSection, managerInfo, setManagerInfo }) {
  const theme = useTheme();
  const toast = useToast();
  const {
    control,
    reset,
    handleSubmit,
    setValue,
    setError,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: managerInfo,
  });

  const onSubmit = values => {
    if (values.password !== values.verifyPassword) {
      return setError('verifyPassword', {
        type: 'custom',
        message: 'very error',
      });
    }
    try {
      setManagerInfo(values);

      setSection(3);
    } catch (error) {
      toast.error(errorMessages(error));
    }
  };

  const password = watch('password');

  useEffect(() => {
    reset(managerInfo);
  }, [managerInfo]);

  return (
    <form action="" onSubmit={handleSubmit(onSubmit)}>
      <AnimationPage>
        <Box
          sx={{
            backgroundColor: '#fafbfc',
            pt: 6,
            pl: 7,
            height: '100vh',
          }}>
          <img src="/images/logo/logoo.svg" alt="logo" />

          <Container maxWidth="lg" sx={{ mt: 13.5 }}>
            {/* <BreadCrumb crumbName={'대표자 정보 입력'} /> */}
            <Paper
              sx={{
                color: theme.palette.info.main,
                boxShadow: '0px 0px 7px #0000001A',
                borderRadius: '10px',
                elevation: 3,
                py: 6,
                px: 7.5,
              }}>
              <Typography
                sx={{
                  fontSize: '30px',
                  lineHeight: '35.8px',
                  fontWeight: 700,
                  color: '#3A3A3A',
                }}>
                대표자 정보 입력
              </Typography>

              <Divider sx={{ border: '1px solid #E7E7E7', mt: 6, mb: 10.87 }} />

              <Grid container columnSpacing={16} sx={{ justifyContent: 'space-between' }}>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={2}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px', color: '#5A5A5A' }}>
                        이름
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputText
                        className="input-large"
                        name="name"
                        control={control}
                        placeholder="이름을 입력해 주세요"
                        rules={{ required: true }}
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
                    <Grid item xs={2}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px', color: '#5A5A5A' }}>
                        아이디
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputText
                        className="input-large"
                        name="username"
                        control={control}
                        rules={{
                          required: true, // Optional: Customize error message
                          pattern: {
                            value: /^[A-Za-z0-9]+$/,
                            message: '아이디는 영문+숫자조합만 가능하도록 함.',
                          },
                        }}
                        placeholder="아이디를 입력해 주세요"
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={2}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px', color: '#5A5A5A' }}>
                        비밀번호
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputText
                        className="input-large"
                        name="password"
                        control={control}
                        rules={{
                          required: '비밀번호는 필수 항목입니다.',
                          pattern: {
                            value: passwordRegex,
                            message: '8자 이상 영문, 숫자, 특수문자 포함',
                          },
                        }}
                        type="password"
                        placeholder="비밀번호를 입력해 주세요(8자 이상 영문,숫자,특수문자포함)"
                        error={!!errors.password}
                        helperText={errors?.password?.message}
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 3.25 }}>
                    <Grid item xs={2}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px', color: '#5A5A5A' }}>
                        비밀번호 확인
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputText
                        className="input-large"
                        name="verifyPassword"
                        control={control}
                        rules={{
                          required: '비밀번호 확인은 필수 항목입니다.',
                          validate: value => value === password || '비밀번호가 일치하지 않습니다.',
                        }}
                        type="password"
                        placeholder="비밀번호를 입력해 주세요(8자 이상 영문,숫자,특수문자포함)"
                        error={!!errors.verifyPassword}
                        helperText={errors?.verifyPassword?.message}
                      />
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={2}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px', color: '#5A5A5A' }}>
                        휴대폰
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputPhone
                        className="input-large"
                        name="phoneNumber"
                        control={control}
                        setValue={setValue}
                        rules={{ required: true }}
                        placeholder="휴대폰 번호를 입력해 주세요"
                      />
                    </Grid>
                  </Box>

                  <Box sx={{ display: 'flex', alignItems: 'center', my: 3.25 }}>
                    <Grid item xs={2}>
                      <Typography sx={{ fontSize: '13px', fontWeight: 500, lineHeight: '24px', color: '#5A5A5A' }}>
                        이메일
                      </Typography>
                    </Grid>
                    <Grid item xs={10}>
                      <FormInputText
                        className="input-large"
                        name="email"
                        control={control}
                        type="email"
                        rules={{ required: true }}
                        placeholder="이메일을 입력해 주세요"
                      />
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Divider sx={{ border: '1px solid #E7E7E7', mt: 12.25, mb: 3 }} />

              <Stack sx={{ flexDirection: 'row', justifyContent: 'end' }}>
                <Button
                  variant="contained"
                  color="secondary"
                  sx={{
                    color: '#fff',
                    borderRadius: '5px',
                    height: 40,
                    minWidth: 125,
                    boxShadow: 'none',
                    mr: 1,
                  }}
                  onClick={() => setSection(1)}>
                  뒤로가기
                </Button>
                <Button variant="contained" color="primary" sx={{ borderRadius: '5px', minWidth: 183 }} type="submit">
                  다음
                </Button>
              </Stack>
            </Paper>
          </Container>
        </Box>
      </AnimationPage>
    </form>
  );
}
